/** @type {number} */
export const STANDARD_IMPORT_UPLOAD_LIMIT_BYTES = 5 * 1024 * 1024;

/**
 * @param {File} file
 * @returns {boolean}
 */
export const isFileTooLargeForStandardImportUpload = (file) => {
  return file.size > STANDARD_IMPORT_UPLOAD_LIMIT_BYTES;
};

/**
 * @param {File} file
 * @param {boolean} hasLargeFileUploads
 * @returns {boolean}
 */
export const shouldSkipImportUpload = (file, hasLargeFileUploads) => {
  return !hasLargeFileUploads && isFileTooLargeForStandardImportUpload(file);
};

/**
 * @param {File} file
 * @returns {string}
 */
export const getImportUploadSkipMessage = (file) => {
  return `${file.name} is over 5MB and cannot be imported without a membership`;
};
